<form
  class="form"
  [attr.id]="idAttribute()"
  [class.is-submitted]="submitted"
  (submit)="triggerSubmit()"
  #formDirectiveRef="ngForm"
  [formGroup]="controls">
  <ng-content></ng-content>

  <ng-content select="[content]"></ng-content>
</form>
